import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { OsaExecucaoAbaFolhaTesteQuestaoHistoricoDetalheComponent } from '../osa-execucao-aba-folha-teste-questao-historico-detalhe/osa-execucao-aba-folha-teste-questao-historico-detalhe.component';
import { ILogModel } from '../../../../../models/log.model';
import { LogService } from '../../../../../services/log.service';
import { IFiltroLog } from '../../../../../models/filtros/filtro-log.model';

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-questao-historico',
  templateUrl: './osa-execucao-aba-folha-teste-questao-historico.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-questao-historico.component.scss']
})

export class OsaExecucaoAbaFolhaTesteQuestaoHistoricoComponent
  implements OnInit, AfterViewInit {

  public filtro: IFiltroLog = {} as IFiltroLog;
  public logs: ILogModel[] = [];
  public identificador: string = "";
  public id: number = 0;
  public idFuncionalidade: number = 35;

  constructor(
    private dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteQuestaoHistoricoComponent>,
    public matDialog: MatDialog,
    public logService: LogService,
    @Inject(MAT_DIALOG_DATA) public data) {

    this.identificador = data?.identificador;
    this.id = data?.id;
    this.idFuncionalidade = data?.idFuncionalidade;
  }

  ngOnInit(): void {

    this.obterLogs(this.id);

  }

  ngAfterViewInit(): void {
    this.configFiltro();
  }

  configFiltro() {
    this.filtro.pagina = 1;
    this.filtro.tamanhoPagina = 1000;
    this.filtro.ordenacaoColuna = "id";
    this.filtro.ordenacaoSentido = "desc";
    this.filtro.funcionalidade = this.idFuncionalidade;
    this.filtro.idRegistro = this.id;
  }

  public obterLogs(id: number) {

    this.configFiltro();

    this.logService
      .obter(this.filtro)
      .then((res) => {
        if (res.sucesso) {
          this.logs = res.dados.resultado;
        }
      })
      .catch((err) => {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "warning",
          text: err?.mensagem?.descricao || 'Erro ao carregar dados',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
  }


  public modalVisualizarHistorico(element: ILogModel) {

    try {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.id = 'modal-folha-teste-questao-historico-detalhe';
      dialogConfig.width = '800px';
      dialogConfig.hasBackdrop = true;
      dialogConfig.disableClose = true;
      dialogConfig.data = {
        historico: element,
      };

      const modal = this.matDialog.open(OsaExecucaoAbaFolhaTesteQuestaoHistoricoDetalheComponent, dialogConfig);
      modal.afterClosed().subscribe((data) => {
        if (data) {
        }
      });
    } catch (err) {
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'error',
        text: err.mensagem.descricao,
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });
    }
  }

  public fechar() {
    this.dialogRef.close();
  }

}

